import { Component, EventEmitter, HostBinding, Inject, Input, Output } from '@angular/core';

import { IBetslipMessages } from '../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';

@Component({
    selector: 'bs-linear-eachway-price-button',
    templateUrl: './eachway-price-button-linear.component.html',
    styleUrls: ['eachway-price-button-linear.component.scss'],
    standalone: false,
})
export class EachwayLinearPriceButtonComponent {
    @Output() toggleEachWay = new EventEmitter<boolean>();
    @Input() isToggled: boolean;
    @HostBinding('class.deselected')
    messages: IBetslipMessages;

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService) {
        this.messages = messageProvider.getMessages();
    }

    onEachwayButtonClick(event: MouseEvent) {
        event.stopPropagation();
        this.toggleEachWay.emit(!this.isToggled);
    }
}
